export const COMMUNITY_ROLES = {
  COMMUNITY_MANAGER: 'community_manager',
  COMMUNITY_MEMBER: 'community_member',
  BOARD_MEMBER: 'board_member',
};

export const COMMUNITY_ROLES_LABELS = {
  [COMMUNITY_ROLES.COMMUNITY_MANAGER]: 'Community Manager',
  [COMMUNITY_ROLES.COMMUNITY_MEMBER]: 'Community Member',
  [COMMUNITY_ROLES.BOARD_MEMBER]: 'Board Member',
};
